import React from "react";
import { Navigate } from "react-router-dom";
import { FILE_SNAP_HUB_ENABLED } from "./fileSnapFlag";

// Route guard for the global File Snap hub. When the build-time feature flag
// is off, the /file-snap route redirects away so the surface is invisible —
// mirroring the backend's FILE_SNAP_HUB_ENABLED gate.
export default function FileSnapFlagGuard({ children }) {
  if (!FILE_SNAP_HUB_ENABLED) return <Navigate to="/dashboard" replace />;
  return children;
}
